module.exports = function() {
  return new Worker(__webpack_public_path__ + "2d308bc748cb8776a206.worker.js");
};